import graphql from "babel-plugin-relay/macro";
import { format } from "date-fns";
import { readInlineData } from "react-relay";

import { packageIsAvailableForSale_package$key } from "./__generated__/packageIsAvailableForSale_package.graphql";

export const packageIsAvailableForSale = (
  packageRef?: packageIsAvailableForSale_package$key | null,
  timeZone?: string
) => {
  const pkg = readInlineData(packageIsAvailableForSaleFragmentRef, packageRef);

  if (!pkg?.displayInApp) return false;

  const { availableFrom, availableTo } = pkg.displayInApp;

  const now = new Date();
  const parts = timeZone
    ? new Intl.DateTimeFormat("en-US", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).formatToParts(now)
    : null;
  const today = parts
    ? ["year", "month", "day"]
        .map((type) => parts.find((part) => part.type === type)?.value)
        .join("-")
    : format(now, "yyyy-MM-dd");

  return (
    (!availableFrom || availableFrom <= today) &&
    (!availableTo || availableTo >= today)
  );
};

const packageIsAvailableForSaleFragmentRef = graphql`
  fragment packageIsAvailableForSale_package on Package @inline {
    displayInApp {
      availableFrom
      availableTo
    }
  }
`;
